/* global ko, _ */

var DisposableViewModel = (function () {
    function dispose(propertiesToIgnore) {
        var self = this;

        if (!Cartegraph.Utilities.isNullOrUndefined(self.vmComputedContext) && self.vmComputedContext.hasOwnProperty("_context"))
            self.vmComputedContext._context = null; // Clean-up potential VM memory leaks in ko.computed (evaluatorFunctionTarget reference to VM)

        for (var property in self) {
            var ignoreProp = propertiesToIgnore.indexOf(property) > -1;
            if (!ignoreProp && self.hasOwnProperty(property) && self[property] != null) {
                if (self[property] == undefined) {
                    self[property] = null;
                    continue;
                }

                if (self[property] instanceof ko.subscription || _.isFunction(self[property].dispose))
                    self[property].dispose();
                if (ko.isObservable(self[property])) {
                    for (var subscriptionType in self[property]._subscriptions) {
                        // subscriptiontype = 'change' etc

                        // each subscriptiontype has an array of subscriptions
                        var subscriptionCount = self[property]._subscriptions[subscriptionType].length;

                        for (var index = 0; index < subscriptionCount; index++) {
                            self[property]._subscriptions[subscriptionType][0].dispose();
                        }

                    }

                    if (self[property].isObservableArray)
                    {
                        self[property]().forEach(function (item) {
                            if (item && _.isFunction(item.dispose)) {
                                item.dispose();
                                item = null;
                            }
                        });
                    }
                }

                self[property] = null;
            }
        }
    }
    return function (propertiesToIgnore) {
        this.dispose = dispose.bind(this, propertiesToIgnore || []);
        return this;
    };
})();